import { render, staticRenderFns } from "./SurveyStep.vue?vue&type=template&id=bd7c7226&"
import script from "./SurveyStep.vue?vue&type=script&lang=js&"
export * from "./SurveyStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports